// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"571":"69e54da43b8a26203903","979":"e0469cbad6498940f011"}[chunkId] + ".js";
};